$(document).on('click', '[data-cookie-close]', function(event) {
  event.preventDefault();
  // Set closed_cookie_tip cookie forever
  const flags = document.location.protocol === 'https:' ? 'SameSite=None;Secure' : '';
  document.cookie = `closed_cookie_tip=1;expires=Fri, 30 Dec 9999 23:59:59 GMT;path=/;${flags}`;
  $(this).closest('.flashmessage').hide();
});
$(document).on('click', '[data-close-notification]', function(event) {
  event.preventDefault();
  const id = $(this).attr('data-close-notification');
  const flags = document.location.protocol === 'https:' ? 'SameSite=None;Secure' : '';
  const expires = $(this).data('notification-expires');
  document.cookie = `closed_notification_${id}=${id};expires=${expires};path=/;${flags}`;
  $(this).closest('.flashmessage').hide().remove();
});
